import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {
  applyOrderUpdateToServices,
  getServiceOrderId,
  OrderPdfStatus,
  resolveOrderPdfStatus
} from 'src/entities/order';
import {
  canShowOrderPdf as canShowOrderPdfFn,
  isPdfReady
} from 'src/entities/order/model/order-status.model';
import { buildOrderPdfDialogConfig } from '../order-pdf-dialog/order-pdf-dialog.config';
import {
  OrderPdfDialogComponent,
  OrderPdfDialogResult
} from '../order-pdf-dialog/order-pdf-dialog.component';

@Component({
  selector: 'app-order-pdf-button',
  templateUrl: './order-pdf-button.component.html',
  styleUrls: ['./order-pdf-button.component.css']
})
export class OrderPdfButtonComponent {
  @Input() row: any;
  @Input() model: any[] = [];
  @Output() pdfStatusChanged = new EventEmitter<void>();

  readonly OrderPdfStatus = OrderPdfStatus;

  constructor(
    private readonly toastr: ToastrService,
    private readonly dialog: MatDialog
  ) {}

  get visible(): boolean {
    return canShowOrderPdfFn(this.row);
  }

  get pdfStatus(): OrderPdfStatus | null {
    return resolveOrderPdfStatus(this.row?.order);
  }

  get isGenerated(): boolean {
    return isPdfReady(this.row?.order?.pdfStatus);
  }

  openPdfDialog(): void {
    const orderId = getServiceOrderId(this.row);

    if (!orderId) {
      this.toastr.warning('No se encontró la Orden de Servicio.');
      return;
    }

    this.dialog
      .open(
        OrderPdfDialogComponent,
        buildOrderPdfDialogConfig({
          orderId,
          orderNumber: this.row?.order?.orderNumber,
          pdfStatus: this.row?.order?.pdfStatus,
          lastPdfError: this.row?.order?.lastPdfError
        })
      )
      .afterClosed()
      .subscribe((result: OrderPdfDialogResult | undefined) => {
        if (!result?.pdfStatus) {
          return;
        }

        this.patchLocalPdfStatus(
          result.pdfStatus,
          result.pdfGeneratedAt ?? null,
          result.lastPdfError ?? null
        );
        this.pdfStatusChanged.emit();
      });
  }

  private patchLocalPdfStatus(
    pdfStatus: string,
    pdfGeneratedAt: string | null,
    lastPdfError: string | null = null
  ): void {
    const update = {
      pdfStatus,
      pdfGeneratedAt,
      lastPdfError
    };

    this.row.order = {
      ...(this.row.order ?? {}),
      ...update
    };

    if (this.model?.length) {
      applyOrderUpdateToServices(
        this.model,
        this.row.order?.orderNumber,
        update,
        this.row
      );
    }
  }
}
